import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import Switch from "@mui/material/Switch";
import moment from "moment/moment";

const CreatePromo = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [des, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [code, setCode] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [image, setImage] = useState("");
  const [link, setLink] = useState("");
  const [cutoffdate, setCutoffdate] = useState("");
  const [cutofftime, setCutofftime] = useState("");
  const [startdate, setStartdate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [sort, setSort] = useState("");
  const [starting, setStarting] = useState("");
  const [ending, setEnding] = useState("");
  const [startTiming, setStartTiming] = useState("");
  const [endTiming, setEndTiming] = useState("");

  const params = useParams();

  useEffect(() => {
    if (startdate || startTime) {
      setStarting(startdate.concat("", startTime));

      setStartTiming(
        moment(starting, "YYYY-MM-DDHH:mm").format("YYYY-MM-DDTHH:mm:ss")
      );
    }

    if (cutoffdate || cutofftime) {
      setEnding(cutoffdate.concat("", cutofftime));

      setEndTiming(
        moment(ending, "YYYY-MM-DDHH:mm").format("YYYY-MM-DDTHH:mm:ss")
      );
    }
  });

  React.useEffect(() => {
    if (open) {
      if (Object.keys(editData).length === 0) {
        setTitle(editData?.title);
        setDescription(editData?.description);
        setIsActive(editData?.isActive ? editData?.isActive : false);
        setImage(editData?.banner_url);
        setSort(editData?.sort ? editData?.sort : "");
        setLink(editData?.link ? editData?.link : "");
        setCutoffdate("");
        setCutofftime("");
        setStartdate("");
        setStartTime("");
      } else {
        setTitle(editData?.title);
        setDescription(editData?.description);
        setIsActive(editData?.isActive || false);
        setImage(editData?.banner_url);
        setSort(editData?.sort);
        setLink(editData?.link);
        setCutoffdate(moment(editData?.endTime).format("YYYY-MM-DD"));
        setCutofftime(moment.utc(editData?.endTime).format("HH:mm"));
        setStartdate(moment(editData?.startTime).format("YYYY-MM-DD"));
        setStartTime(moment.utc(editData?.startTime).format("HH:mm"));
      }
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };

  const onImageChange = (event) => {
    // console.log(event.target.files[0]);
    const { files } = event.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      // console.log(url);
      // setImage(url);
      UploadImage(url, files[0]);
    }
  };
  const UploadImage = (url, files) => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        setIsLoading(false);
        SuccesToast(result.message);
        setImage(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  const handleOk = () => {
    if (title && des && image) {
      let url = editData?.id
        ? `${endPoints.api.UPDATE_IMAGE}`
        : `${endPoints.api.ADD_IMAGE}`;
      let payload = {
        title: title,
        description: des,
        banner_url: image,
        sort: sort,
        link: link,
        startTime: startTiming,
        endTime: endTiming,
        isActive: isActive,
        // startdate:startdate,
        // starttime:startTime,
        // cutoffdate:cutoffdate,
        // cutofftime:cutofftime
      };

      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            // console.log("image",image);
            onClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };

  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Banner Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Title"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Description"
            value={des}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "100%", marginTop: "30px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Link"
            value={link}
            onChange={(event) => {
              setLink(event.target.value);
            }}
          />
        </FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Sort Number</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Time"
            type="number"
            maxValue="5"
            minValue="1"
            value={sort}
            onChange={(event) => {
              setSort(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Date</label>
          {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="date"
            value={startdate}
            onChange={(event) => {
              setStartdate(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Time</label>
          {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="time"
            value={startTime}
            onChange={(event) => {
              setStartTime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Cutoff Date</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Date"
            type="date"
            value={cutoffdate}
            onChange={(event) => {
              setCutoffdate(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Cutoff Time</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Time"
            type="time"
            value={cutofftime}
            onChange={(event) => {
              setCutofftime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <Form.Control
          style={{ marginTop: "25px", marginBottom: "20px", width: "100%" }}
          id="filled-required"
          variant="outlined"
          label="image"
          // value={image}
          name={image}
          onChange={onImageChange}
          type="file"
        />

        <FormControlLabel
          control={
            <Switch
              name="active"
              value={isActive}
              onClick={() => {
                setIsActive(!isActive);
              }}
              defaultChecked={isActive}
            />
          }
          labelPlacement="start"
          label="Active"
        />

        {/* <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Price"
            value={price}
            onChange={(event) => {
              setPrice(event.target.value);
            }}
          />
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Code"
            value={code}
            //  type="number"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setCode(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Player Count"
            value={playerCount}
            onChange={(event) => {
              setPlayerCount(event.target.value);
            }}
          />
        </FormControl> */}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreatePromo;
